import { render, staticRenderFns } from "./SelectGlobalWidget.vue?vue&type=template&id=57503072&scoped=true"
import script from "./SelectGlobalWidget.vue?vue&type=script&lang=js"
export * from "./SelectGlobalWidget.vue?vue&type=script&lang=js"
import style0 from "./SelectGlobalWidget.vue?vue&type=style&index=0&id=57503072&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57503072",
  null
  
)

export default component.exports